<template>
<div> 
    <v-autocomplete 
        autocomplete="off"
        :filled="!outlined"
        :outlined="outlined"
        :label="label"
        :value="myValue"
        :items="items"
        :hint="hint"
        :rules="rules"
        :disabled="disabled"
        :item-text="item_text"
        :item-value="item_value"
        :return-object="return_object"
        :loading="loading"
        @input="myInput"
        :search-input.sync="search"
        :filter="filterBy"
        :clearable="clearable"
        v-bind="vbind"
        v-on="von"
        class="rounded-lg app-autocomplete-no-border"
    >
        <template #prepend-inner v-if="prependInnerIcon">
        <v-icon color="primary" left>
            {{prependInnerIcon}}
        </v-icon>
        </template>
        <template slot="item" slot-scope="data">
            {{ data.item[item_search_field] }}
        </template>
    </v-autocomplete>
</div>
</template>

<script>
import { client } from "@/api/client"

export default {
    name: 'AppAutocompleteWithApi',
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            type: [String, Number, Object],
            default: undefined,
        },
        url: {
            type: String,
            required: true
        },
        starting_items: {
            type: Array,
            default: [],
        },
        
        return_object: {
            type: Boolean,
            default: false,
        },
        item_text: {
            type: String,
            default: 'name'
        },
        item_search_field: {
            type: String,
            default: 'name'
        },
        item_value: {
            type: String,
            default: 'id',
        },
        disabled: {
            type: Boolean,
            default: false
        },
        vbind: {
            type: Object,
            default: undefined
        },
        von: {
            type: Object,
            default: undefined
        },
        hint: {
            type: String,
            default: ''
        },
        rules: {
            type: Array,
            default: () => []
        },
        prependInnerIcon: {
            type: String,
            default: ''
        },
        clearable: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            myValue: '',
            items: [],
            search: null,
            loading: false,
            api_call: 0,
        }
    },
    methods: {
        myInput(value) {
            this.myValue = value;
            this.$emit('input', value);
        },
        getItems(val) {
            this.loading = true;
            let path = this.url;
            if (val) {
                let search_text = encodeURIComponent(val)
                path = path + '&search_text=' + search_text;
            }
            this.api_call += 1
            let curr_call = this.api_call
            client.get(path).then(response => {
                if (curr_call == this.api_call){
                    this.items = response.data.results;
                }
               
            }).catch(error => { 
                console.debug(error);
            }).finally(() => {
                this.loading = false;
            });
        },
        filterBy(item, queryText, itemText) {
            const text = item[this.item_search_field].toLowerCase();
            const searchText = queryText.toLowerCase();
            return text.indexOf(searchText) > -1;
        },
    },
    mounted() {
        this.myValue = this.value;
        if (this.value && Object.keys(this.myValue).includes(this.item_search_field)) {
            this.getItems(this.myValue[this.item_search_field]);
        }
        else {
            this.getItems('');
        }
    },
    watch:{
        value(val) {
            this.myValue = val;
            if (val && Object.keys(this.myValue).includes(this.item_search_field)) {
                this.getItems(this.myValue[this.item_search_field]);
            } else {
                this.getItems('');
            }
        },
        search(val) {
            this.getItems(val);
        }
    }
}
</script>